export default {
  delete: {
    padding: "32px 0px 0px"
  }
};



// WEBPACK FOOTER //
// ./src/components/app/registration/product/form/kit-info/styles.js